<template>
  <PopUpModal ref="popup">
    <div class="m-3">
      <div class="row w-50 img-fluid m-auto">
        <img
          :src="image"
          class="img-fluid"
          alt="question mark image"
        />
      </div>
      <div class="row bb-hdg mt-3 mb-1 justify-content-center text-center">
        {{ title }}
      </div>
      <div class="row bb-sub-hdg mt-3 mb-1 justify-content-center text-center">
        {{ message }}
      </div>
      <div
        v-if="subject"
        class="row bb-sub-sub-hdg mt-2 mb-3 justify-content-center text-center"
      >
        {{ subject }}
      </div>
      <div class="d-grid gap-2 mt-3">
        <button
          v-if="cancelButton"
          type="button"
          class="btn btn-lg btn-warning"
          @click="_cancel"
        >
          {{ cancelButton }}
        </button>
        <button
          v-for="status in statuses"
          :key="status.value"
          type="button"
          class="btn btn-lg btn-primary"
          @click="_confirm(status.value)"
        >
          {{ status.label }}
        </button>
      </div>
    </div>
  </PopUpModal>
</template>

<script>
import PopUpModal from './PopUpModal.vue'
import image from '../assets/images/bbQuestionMark96.png'

export default {
  name: 'DeleteArtefactDialog',
  components: {
    PopUpModal,
  },
  data: () => ({
    title: 'Delete Artefact',
    message: 'Confirm Reason',
    subject: undefined,
    cancelButton: 'Cancel',
    statuses: [],
    resolvePromise: undefined,
    rejectPromise: undefined,
    image,
  }),
  methods: {
    show(opts = {}) {
      this.title = opts.title || 'Delete Artefact'
      this.message = opts.message || 'Confirm Reason'
      this.subject = opts.subject
      this.cancelButton = opts.cancelButton || 'Cancel'
      this.statuses = Array.isArray(opts.statuses) ? opts.statuses : []
      this.$refs.popup.open()

      return new Promise((resolve, reject) => {
        this.resolvePromise = resolve
        this.rejectPromise = reject
      })
    },
    _confirm(status) {
      this.$refs.popup.close()
      this.resolvePromise(status)
    },
    _cancel() {
      this.$refs.popup.close()
      this.resolvePromise(null)
    },
  },
}
</script>
